module.exports = __webpack_public_path__ + "img/symbol_16.92b548bb.png";